class BackToTop extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector('[data-back-to-top]');
    this.scrollThreshold = 800;
    this.filterContentEl = null;
    
    this.init();
  }

  init() {
    // Cache the filter content element - check for data-filter-content or blog-filter element
    this.filterContentEl = document.querySelector('[data-filter-content]') || 
                          document.querySelector('blog-filter');
    
    // Handle scroll events
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    
    // Handle resize to update mobile state
    this.handleResize = this.handleResize.bind(this);
    window.addEventListener('resize', this.handleResize, { passive: true });
    
    // Handle button click
    if (this.button) {
      this.button.addEventListener('click', this.scrollToTop.bind(this));
    }
    
    // Check initial scroll position
    this.handleScroll();
  }

  get isMobile() {
    return window.innerWidth < 768;
  }

  handleResize() {
    // Recheck scroll state on resize
    this.handleScroll();
  }

  handleScroll() {
    let shouldShow = false;

    if (this.isMobile) {
      // On mobile: fixed 800px threshold
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      shouldShow = scrollPosition > this.scrollThreshold;
    } else {
      // On desktop: check if filter content exists and is scrolled past
      if (this.filterContentEl) {
        const rect = this.filterContentEl.getBoundingClientRect();
        // Show button when filter content is completely scrolled past (out of view)
        shouldShow = rect.bottom < 0;
      } else {
        // Fallback to fixed threshold if no filter content exists
        const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        shouldShow = scrollPosition > this.scrollThreshold;
      }
    }

    if (shouldShow) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  scrollToTop(event) {
    event.preventDefault();
    
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.handleResize);
  }
}

customElements.define('back-to-top', BackToTop);
